import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const firstAsync = async (source, predicate) => {
    for await (const value of source) {
        if (await predicate(value) === true) {
            return value;
        }
    }
    throw new InvalidOperationException(ErrorString.NoMatch);
};
